/*
  Judge.me product reviews: show 12 on first load (LOC-095), and give the
  widget real headings: the product name in its H2, an H3 over the fit and
  comfort averages and an H3 for the customer photos (LOC-096).

  Judge.me renders 3 reviews into the page and fetches the rest 3 at a time,
  and its per-page number is an app setting the theme cannot change. Once the
  widget has finished its own setup, this asks Judge.me's Load more for page 1
  at 12 per page. The 3 rendered reviews stay hidden, not removed, until the
  12 arrive, so nothing jumps and nothing is lost if the request fails: after
  8 seconds without new reviews the original 3 and the original paging come
  back. From then on Judge.me pages in twelves (sorting too) and removes Load
  more itself when there is nothing left, so a product with 12 or fewer
  reviews shows them all with no button. Products with 3 or fewer reviews have
  no Load more and are left alone.
*/
(function () {
  var TARGET = 12;
  var TIMEOUT = 8000;
  var WIDGET_ID = 'judgeme_product_reviews';

  function readyClass() {
    return (window.jdgm && window.jdgm.DONE_SETUP_WIDGET_CLASS) || 'jdgm--done-setup-widget';
  }

  function topUp(widget) {
    var list = widget.querySelector('.jdgm-rev-widg__reviews');
    var paginate = widget.querySelector('.jdgm-paginate');
    var more = paginate && paginate.querySelector('.jdgm-paginate__load-more');
    if (!list || !paginate || !more || widget.hasAttribute('data-reviews-topped-up')) return;

    var perPage = parseInt(paginate.getAttribute('data-per-page'), 10) || 0;
    if (perPage >= TARGET) return;

    var originals = Array.prototype.slice.call(list.querySelectorAll('.jdgm-rev'));
    var originalPage = more.getAttribute('data-page');
    var finished = false;
    var timer;

    widget.setAttribute('data-reviews-topped-up', 'pending');
    list.style.minHeight = list.offsetHeight + 'px';
    originals.forEach(function (review) {
      review.setAttribute('data-reviews-original', '');
      review.style.display = 'none';
    });

    var observer = new MutationObserver(function () {
      if (list.querySelector('.jdgm-rev:not([data-reviews-original])')) finish(true);
    });

    function finish(ok) {
      if (finished) return;
      finished = true;
      observer.disconnect();
      clearTimeout(timer);
      if (ok) {
        originals.forEach(function (review) {
          if (review.parentNode) review.parentNode.removeChild(review);
        });
        widget.setAttribute('data-reviews-topped-up', 'done');
      } else {
        originals.forEach(function (review) {
          review.style.display = '';
          review.removeAttribute('data-reviews-original');
        });
        paginate.setAttribute('data-per-page', String(perPage));
        if (originalPage !== null) more.setAttribute('data-page', originalPage);
        widget.setAttribute('data-reviews-topped-up', 'failed');
      }
      list.style.minHeight = '';
    }

    observer.observe(list, { childList: true, subtree: true });
    timer = setTimeout(function () { finish(false); }, TIMEOUT);
    paginate.setAttribute('data-per-page', String(TARGET));
    more.setAttribute('data-page', '1');
    more.click();
  }

  function productName() {
    var el = document.querySelector('.product__title [data-zoom-caption]');
    return el ? el.textContent.trim() : '';
  }

  // Judge.me titles every widget "Reviews". The product name makes that H2 say what it covers.
  function retitle(widget, name) {
    var title = widget.querySelector('.jdgm-rev-widg__title');
    if (title && name) title.textContent = name + ' reviews';
  }

  // An H3 over the averages, worded from the widget's own labels: "Villain Slip fit and comfort".
  function averagesHeading(widget, name) {
    var avg = widget.querySelector('.jdgm-custom-forms-avg-responses');
    if (!avg || !name || widget.querySelector('.jdgm-avg-heading')) return;
    var labels = [];
    Array.prototype.forEach.call(avg.querySelectorAll('.jdgm-rev__cf-ans__title'), function (label) {
      // Some products carry the same rating question twice, so the widget shows Fit and Comfort twice.
      var text = label.textContent.replace(/[\s:]+$/, '').trim().toLowerCase();
      if (text && labels.indexOf(text) === -1) labels.push(text);
    });
    if (!labels.length) return;
    var last = labels.pop();
    var heading = document.createElement('h3');
    heading.className = 'jdgm-avg-heading';
    heading.textContent = name + ' ' + (labels.length ? labels.join(', ') + ' and ' + last : last);
    avg.parentNode.insertBefore(heading, avg);
  }

  // Judge.me adds the photos title as a div after load. It becomes an H3 with the same class.
  function galleryHeading(widget) {
    Array.prototype.forEach.call(widget.querySelectorAll('div.jdgm-gallery-title'), function (div) {
      var heading = document.createElement('h3');
      heading.className = div.className;
      while (div.firstChild) heading.appendChild(div.firstChild);
      div.parentNode.replaceChild(heading, div);
    });
  }

  function init() {
    var widget = document.getElementById(WIDGET_ID);
    if (!widget) return;
    var start = function () {
      var name = productName();
      retitle(widget, name);
      averagesHeading(widget, name);
      galleryHeading(widget);
      new MutationObserver(function () {
        if (widget.querySelector('div.jdgm-gallery-title')) galleryHeading(widget);
      }).observe(widget, { childList: true, subtree: true });
      setTimeout(function () { topUp(widget); }, 400);
    };
    if (widget.classList.contains(readyClass())) return start();
    var watcher = new MutationObserver(function () {
      if (widget.classList.contains(readyClass())) {
        watcher.disconnect();
        start();
      }
    });
    watcher.observe(widget, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
